import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0a1628] shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/57dc7616-db30-48df-be75-7723beb17ec9.png" 
                alt="Logo" 
                className="h-10 w-auto"
              />
            </Link>
          </div>

          <nav className="hidden lg:flex items-center space-x-8">
            <Link to="/about" className="text-white hover:text-teal-400 transition-colors text-sm whitespace-nowrap">
              회사 소개
            </Link>
            
            <div className="relative group">
              <button className="text-white hover:text-teal-400 transition-colors text-sm whitespace-nowrap flex items-center">
                솔루션
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                <Link to="/solutions/toto" className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 text-sm whitespace-nowrap">토토 솔루션</Link>
                <Link to="/solutions/sports" className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 text-sm whitespace-nowrap">스포츠 배팅 솔루션</Link>
                <Link to="/solutions/casino" className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 text-sm whitespace-nowrap">카지노 솔루션</Link>
                <Link to="/solutions/slot" className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 text-sm whitespace-nowrap">슬롯 솔루션</Link>
                <Link to="/solutions/poker" className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 text-sm whitespace-nowrap">포커 솔루션</Link>
                <Link to="/solutions/bitcoin" className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 text-sm whitespace-nowrap">비트코인 배팅 솔루션</Link>
              </div>
            </div>

            <div className="relative group">
              <button className="text-white hover:text-teal-400 transition-colors text-sm whitespace-nowrap flex items-center">
                제품
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                <Link to="/products/license" className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 text-sm whitespace-nowrap">겜블링 라이선스</Link>
                <Link to="/products/korean-payment" className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 text-sm whitespace-nowrap">한국 결제 시스템</Link>
                <Link to="/products/international-payment" className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 text-sm whitespace-nowrap">해외 결제 시스템</Link>
              </div>
            </div>

            <Link to="/customer-stories" className="text-white hover:text-teal-400 transition-colors text-sm whitespace-nowrap">
              고객 사례
            </Link>
            <Link to="/blog" className="text-white hover:text-teal-400 transition-colors text-sm whitespace-nowrap">
              블로그
            </Link>
          </nav>

          <div className="hidden lg:block">
            <a 
              href="https://t.me/realtad_cs" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-teal-500 hover:bg-teal-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              상담 텔레그램 문의
            </a>
          </div>

          <button 
            className="lg:hidden text-white text-2xl cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-[#0a1628] border-t border-gray-700">
          <div className="px-4 py-4 space-y-3">
            <Link to="/about" className="block text-white hover:text-teal-400 py-2 text-sm whitespace-nowrap">회사 소개</Link>
            <Link to="/customer-stories" className="block text-white hover:text-teal-400 py-2 text-sm whitespace-nowrap">고객 사례</Link>
            <Link to="/blog" className="block text-white hover:text-teal-400 py-2 text-sm whitespace-nowrap">블로그</Link>
            <a 
              href="https://t.me/realtad_cs" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block bg-teal-500 hover:bg-teal-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium text-center whitespace-nowrap cursor-pointer"
            >
              상담 텔레그램 문의
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
